import React from 'react';

import type { CommonButtonLinkProps } from '../types';
import * as styles from './HyperButton.styles';

export const HyperButtonLink = ({ active, children, ...props }: CommonButtonLinkProps) => (
  <a data-is-active={active} {...props} css={styles.hyperButtonLink}>
    {children}
  </a>
);
